import messageResource from '../../../../../messageResource'
import TemplateView from '../../../../../TemplateView'
import Button from '../../../../../components/Button'


export default class ConfigureAccountFooter extends TemplateView {
    constructor({
        continueButtonClickCallback = () => {},
        backButtonClickCallback = () => {},
    } = {}) {
        super()

        this.callbacks = {
            continueButtonClickCallback,
            backButtonClickCallback,
        }

        this.state = {
            continueDisabled: false,
        }

        this.onStatePropertyChanged('continueDisabled', (disabled) => {
            this.continueButton.setState({disabled})
        })
    }

    templateHtml() {
        return '<div class="accountInfoFooter"/>'
    }

    afterRender() {
        new Button({
            additionalClass: 'backButton cancelButton',
            label: messageResource.getMessage('licenses.purchase_lightbox.back'),
            onClickCb: () => this.callbacks.backButtonClickCallback(),
        }).init(this.getEl())
        this.continueButton = new Button({
            additionalClass: 'continueButton',
            label: messageResource.getMessage('licenses.purchase_lightbox.account_info_continue'),
            onClickCb: () => this.callbacks.continueButtonClickCallback(),
        }).init(this.getEl())
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/accountInfo/ConfigureAccountFooter.js